<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> {{language2[1]['Home']}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/setting/index"> {{language2[9]['Manage Language']}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>  {{language2[87]['Update Label']}}</h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style="padding-bottom: 300px;" class="container-fluid">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


                    <form @submit.prevent="SaveUrl()" >

<div class="row">
 
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language2[83]['English Name']}} </label>
            <input  v-model="language.english"  style="font-size: small;" class="form-control" required disabled>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group">
            <label class="custom-label" style="font-size: small;">{{language2[84]['Swedish Name']}}</label>
            <input  v-model="language.swedish"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group">
            <label class="custom-label" style="font-size: small;">Chinese</label>
            <input  v-model="language.chinese"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group">
            <label class="custom-label" style="font-size: small;">Japanese</label>
            <input  v-model="language.Japanese"  style="font-size: small;" class="form-control" >
    </div>
  </div>
 

  
</div>


<div class="row">
 
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Deutsch </label>
            <input  v-model="language.Deutsch"  style="font-size: small;" class="form-control"  >
    </div>
  </div>


  </div>
















   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">{{language2[78]['Update']}}</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           
            </div>
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
            this.loadLabel()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            id:this.$route.query.id,
            language2:JSON.parse(authService.isLanguage()),
        total:0,
        selectedOption: null, // Store the selected option
       

        brands:[],
        suppliers:[],
        vehicles:[],
        Locations:[],
        language:{},
       
      
      
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    
            async loadLabel() {
       
       console.log(this.url);
    
     console.log("amila");
        try {
          const { data} = await  axios.post('/issuetracking/languageupdate?id='+this.id,{
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
           this.language = data.language;
           
            
          
        } catch (error) {
          console.log(error.response);
        }
      },
       

    async SaveUrl() {
       
      console.log(this.url);
   
    console.log("amila");
       try {
         const { data} = await  axios.post('/issuetracking/languageupdate2?id='+this.id,{userid:this.userid,language:this.language},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.loadlanguage();
          this.$router.push('/setting/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },


     async loadlanguage() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  axios.get('/user/loadlanguage',{
        headers:{
          // 'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       const detailsArray = data.details;
       localStorage.setItem('LANGUAGE', JSON.stringify(detailsArray))
       window.location.reload();
      
    } catch (error) {
      console.log(error.response);
    }
  },
       

     

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    